module.exports = __webpack_public_path__ + "img/history_timeline_4.4f936a8f.png";